import React, { useEffect, useRef, useState } from "react";
import Header from "../../../Components/comman/Header";
import SideMenu from "../SideMenu";
import { Button, Form, Modal, Tab } from "react-bootstrap";
import { BsPlusCircle } from "react-icons/bs";
import Images from "../../../Helpers/Images";
import { useNavigate } from "react-router-dom";
import MobileHeader from "../../../Components/comman/MobileHeader";
import { APIRequest, ApiUrl } from "../../../Helpers/ApiHelper";
import { Notification, toaster } from "rsuite";
import MyCampaign from "../../../Components/Brands/MyCampaign";
import { FaSearch } from "react-icons/fa";

const CampaginHome = () => {
  const [showAddModal, setShowAddModal] = useState(false);
  const navigate = useNavigate();
  const [campaignTitle, setCampaignTitle] = useState("");
  const [error, setError] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const debounceTimer = useRef(null);
  const handleClose = () => {
    setShowAddModal(false);
  };
  const handleContinue = async () => {
    if (!campaignTitle.trim()) {
      setError("Campaign title is required.");
    }
    let config = {
      url: ApiUrl.createCampaign,
      method: "POST",
      body: {
        campaign_title: campaignTitle,
      },
    };
    setIsLoading(true);
    APIRequest(
      config,
      (res) => {
        navigate(`/brand/campaign/${res?.campaign?.id}`, {
          state: { title: res?.campaign?.campaign_title },
        });
      },
      (err) => {
        if (err?.response?.status === 422) {
          console.log("error++", err?.response?.data?.message);
          toaster.push(
            <Notification type="error" header="error" closable>
              {err?.response?.data?.message}
            </Notification>,
            {
              placement: "topCenter",
            }
          );
        } else if (err.response.status === 401) {
          toaster.push(
            <Notification type="error" header="error" closable>
              {err?.response?.data?.message}
            </Notification>,
            {
              placement: "topCenter",
            }
          );
        }
        setIsLoading(false);
      }
    );
  };
  useEffect(() => {
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    debounceTimer.current = setTimeout(() => {
      setSearchQuery(searchValue);
    }, 500);

    return () => clearTimeout(debounceTimer.current);
  }, [searchValue]);
  const handleShowModal = () => setShowAddModal(true);
  const handleSearch = (query) => {
    console.log("Search query:", query);
  };
  const handleClear = () => {
    setSearchValue("");
    setSearchQuery("");
  };

  return (
    <div className="brand-dashboard-wrapper">
      <Header />
      <MobileHeader />
      <div className="brand-dashboard-inner ">
        <Tab.Container activeKey={`campaigns`}>
          <SideMenu />
          <div className="brand-dashboard-content-wrapper">
            <Tab.Content>
              <Tab.Pane eventKey={"campaigns"}>
                <div className="brand-campagin-wrapper">
                  <div className="brand-campagin-inner">
                    <h6 className="heading-title">My Campaigns</h6>
                    <div className="bcamp-searchbar-box">
                      <div className="searchBar-filter">
                        <input
                          type="text"
                          placeholder="Search campaigns..."
                          value={searchValue}
                          onChange={(e) => setSearchValue(e.target.value)}
                          className="searchbar-input"
                        />
                        {searchValue && (
                          <button
                            onClick={handleClear}
                            className="searchbar-clear"
                          >
                            ×
                          </button>
                        )}
                        <span className="searchbar-icon">
                          <FaSearch />
                        </span>
                      </div>
                      <Button
                        to="/campaign/:id"
                        className="add-btn"
                        onClick={handleShowModal}
                      >
                        <BsPlusCircle />
                        Add Campaign
                      </Button>
                    </div>
                    <div className="content-area">
                      <MyCampaign
                        handleShowModal={handleShowModal}
                        searchQuery={searchQuery}
                      />
                    </div>
                  </div>
                </div>
              </Tab.Pane>
            </Tab.Content>
          </div>
        </Tab.Container>
      </div>
      {/* modal */}
      <Modal
        className="analytics-modal addCampagin-modal"
        show={showAddModal}
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Campaign</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-content">
            <h6>Let's name your campaign</h6>
            <p>
              What is your campaign promoting? Be descriptive but brief. Try not
              to include your brand's name.
            </p>
          </div>
          <Form>
            <Form.Label>Campaign Title</Form.Label>
            <Form.Control
              type="text"
              placeholder="e.g. My Campaign"
              autoFocus
              onChange={(e) => setCampaignTitle(e.target.value)}
            />
            {error && <div className="text-danger mt-2">{error}</div>}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleContinue}>Continue</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CampaginHome;
